﻿import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BreadcrumbModule } from '../../core/breadcrumb/breadcrumb.module';
import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { DebateBasicDataComponent } from './debate-basic-data/debate-basic-data.component';
import { DebatesContactPersonListComponent } from './debates-contact-person-list/debates-contact-person-list.component';
import { DebatesResponsiblePersonListComponent } from './debates-responsible-person-list/debates-responsible-person-list.component';
import { DebateFilesComponent } from './debate-files/debate-files.component';

@NgModule({
    declarations: [
        DebateBasicDataComponent,
        DebatesContactPersonListComponent,
        DebatesResponsiblePersonListComponent,
        DebateFilesComponent
    ],
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        BreadcrumbModule        
    ],
    exports: [
        DebateBasicDataComponent,
        DebatesContactPersonListComponent,
        DebatesResponsiblePersonListComponent,
        DebateFilesComponent
    ],
    providers: []
})
export class SharedDebatesModule { }